import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { AgrPageModule, AgrPrimaryActionModule } from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { BusinessPartnerBackofficeComponent } from './business-partner-backoffice.component';

import { SharedModule } from '../shared/shared.module';
import { BusinessPartnerBackofficeEffects } from './store/effects/business-partner-backoffice.effects';

import { businessPartnerBackofficeReducer } from './store/reducers/business-partner-backoffice.reducer';

@NgModule({
  declarations: [BusinessPartnerBackofficeComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatSortModule,
    MatCardModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatIconModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule,
    MatSelectModule,
    MatTreeModule,
    MatSlideToggleModule,
    AgrPageModule,
    AgrFormModule,
    AgrPrimaryActionModule,
  ],
  providers: [
    provideState('businessPartnerBackofficeModule', businessPartnerBackofficeReducer),
    provideEffects([BusinessPartnerBackofficeEffects]),
  ],
  exports: [],
})
export class BusinessPartnerBackofficeModule {}
